function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  *,\n  *:after,\n  *:before {\n    box-sizing: border-box;\n  }\n\n  body {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-variant-ligatures: no-common-ligatures;\n    margin: 0;\n    padding: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { injectFontFiles } from './typography';
import { injectGlobal } from 'styled-components';
export { BorderRadius, CaviarColors, Colors, Themes, ThemingContext, Theming, ThemingConsumer, withTheming } from './theming';
export { Icon } from './icons';
export { default as Shadows } from './shadows';
export { Spacing, Stack, StackChildren, Inset, Inline, InlineChildren } from './spacing';
export { fontFamily, Text, themedFontFamily, injectFontFiles, getResolvedWeightWithTheme } from './typography';
export { Media, Breakpoints } from './mediaQueries';
export { default as getFocusStyles } from './focus';
export { encodeIconSVG } from './icons/utils';
/* eslint-disable no-unused-expressions */

injectFontFiles();
injectGlobal(_templateObject());